import pRetry, { FailedAttemptError } from "p-retry";

type RetryOptions = {
  retries?: number;
  factor?: number;
  minTimeout?: number;
  maxTimeout?: number;
};

const HTTP_ERROR_STATUS = [500, 502, 503, 504];

const hasHttpErrorStatus = (error: FailedAttemptError) =>
  HTTP_ERROR_STATUS.some((status) => {
    return error.message.includes(`Status: ${status}`);
  });

const shouldRetry = (error: FailedAttemptError) => {
  // 網路錯誤 (fetch 失敗)
  if (
    error.name === "TypeError" ||
    error.message?.includes("fetch") ||
    error.message?.includes("network")
  ) {
    return true;
  }

  // 檢查 HTTP 狀態碼 >= 500
  if (hasHttpErrorStatus(error)) {
    return true;
  }

  return false;
};

export const withRetry = async <T>(
  requestFn: () => Promise<T>,
  options: RetryOptions = {}
) => {
  const {
    retries = 3,
    factor = 2,
    minTimeout = 1000,
    maxTimeout = 5000,
  } = options;

  return pRetry(requestFn, {
    retries,
    factor,
    minTimeout,
    maxTimeout,
    shouldRetry,
  });
};
